// import { gsap } from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

if (document.querySelector('.HowItWorks_hiw-bottom__T6B5E')) {
  setTimeout(() => {
    const blocks = Array.from(document.querySelector('.HowItWorks_hiw-section__QwDoR').children).filter((e, i) => i !== 0)
    const height = blocks.reduce((h, el) => (h += el.offsetHeight), 0)

    gsap.to('.HowItWorks_hiw-bottom__T6B5E', {
      scrollTrigger: {
        trigger: '.HowItWorks_hiw-bottom__T6B5E',
        pin: true, // Закріплює елемент
        start: `top top+=${window.headerHeight}`, // Початок анімації (верх елемента при верхній частині вікна)
        end: `+=${height}`, // Кінець анімації (500px після старту)
        pinSpacing: false, // Вимкнення простору, який залишається після закріплення
      },
    })
  }, 100)
}

const yEls = document.querySelectorAll('[data-anim-y]')

if (yEls.length) {
  yEls.forEach(el => {
    const TOP = 150
    const startTop = Math.min(TOP, el.offsetHeight)

    gsap.from(el, {
      y: 80,
      duration: 1,
      ease: 'power1.out',
      scrollTrigger: {
        trigger: el,
        start: `top+=${startTop} bottom`,
        end: `top+=${startTop} bottom`,
      },
    })
  })
}
